module.exports = __webpack_public_path__ + "img/katalogwand.svg";